<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent != null && localService.languageContent.startup">
  <app-popup-header title="{{localService.languageContent.startup.header}}"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-3">
        <span>{{localService.languageContent.startup.order_nbr}}</span>
      </div>
      <div class="col-3">
        <span>:&nbsp;</span>
        <input autocomplete="off" type="number" class="number en" (keypress)="localService.isNumberOnly($event)" style="width:50px;" [(ngModel)]="wrapper.content.v2" />
      </div>
      <div class="col-6">
        <label style="font-weight:normal;">
          <input type="checkbox" [(ngModel)]="isHidden">
          <span style="font-size:16px;color:darkslategrey">&nbsp;{{localService.languageContent.startup.isHidden}}</span>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <ngx-select *ngIf="types" [(ngModel)]="wrapper.content.v4" [optionValueField]="'key'" [optionTextField]="'value'" [items]="types" [noAutoComplete]="true" placeholder="{{localService.languageContent.startup.select_type}}" title="{{localService.languageContent.startup.select_type}}">
        </ngx-select>
      </div>
      <div class="col-3">
        <span>{{localService.languageContent.startup.page_key}}</span>
      </div>
      <div class="col-3">
        <input autocomplete="off" type="number" class="number en" (keypress)="localService.isNumberOnly($event)" min="1" [(ngModel)]="wrapper.content.v5" />
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <span>{{localService.languageContent.startup.icon}}</span>
      </div>
      <div class="col-9">
        :&nbsp;<input autocomplete="off" type="text" class="en" [(ngModel)]="wrapper.content.v3" />
      </div>
    </div>
    <app-language-container [MaxLength]="200" [(languageContents)]="wrapper.languageContents" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [IsShowAllLanguages]="true"></app-language-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
